import { User } from '@/types/auth'
import { StorageSerializers, useStorage } from '@vueuse/core'
import { parse } from 'date-fns'
import { defineStore } from 'pinia'

interface States {
  token: Ref<string | null>
  user: Ref<User | null>
}

export const useAuthStore = defineStore('auth', () => {
  const states: States = {
    token: useStorage('token', null),
    // Note: https://vueuse.org/core/useStorage/#custom-serialization
    // when you provide null as the default value, useStorage can't assume the data type from it.
    // In this case, you can provide a custom serializer or reuse the built-in ones explicitly.
    user: useStorage('user', null, undefined, { serializer: StorageSerializers.object }),
  }

  const getUserFullName = computed(() => {
    return `${states.user.value?.first_name} ${states.user.value?.last_name}`
  })

  const getUserJoinedAt = computed(() => {
    if (states.user.value) {
      const userCreatedDate = parse(states.user.value.date_joined, 'MM-dd-yyyy HH:mm', new Date())
      const unixTimestamp = Math.floor(userCreatedDate.getTime() / 1000)

      return unixTimestamp
    }
    return 0
  })

  const resetStore = () => {
    for (const key in states) {
      states[key as keyof States].value = null
    }
  }

  const resetAllStores = () => {
    const businessStore = useBusinessStore()
    const entityStore = useEntityStore()
    const campaignStore = useCampaignStore()
    const productStore = useProductStore()
    const miscStore = useMiscStore()
    const priceAlertStore = usePriceAlertStore()

    resetStore()
    businessStore.resetStore()
    entityStore.resetStore()
    campaignStore.resetStore()
    productStore.resetStore()
    miscStore.resetStore()
    priceAlertStore.resetStore()
  }

  return {
    ...states,
    getUserFullName,
    getUserJoinedAt,
    resetAllStores,
  }
})
